<template>
    <PageFrameInset maxWidth="500px">
        <div class="register page">
            <div class="form-group form-group-header">
                <h1>Register</h1>
            </div>
            <div class="form-group">
                <OSJLabel
                    :theme="theme"
                    :size="size"
                    required>
                    Email
                </OSJLabel>
                <OSJInput
                    placeholdertext="email@mail.com"
                    inputtype="email"
                    v-model="email"
                    required>
                </OSJInput>
            </div>

            <div class="form-group">
                <OSJLabel
                    :theme="theme"
                    :size="size"
                    required>
                    Password
                </OSJLabel>
                <OSJInput
                    inputtype="password"
                    v-model="password"
                    required>
                </OSJInput>
            </div>

            <div class="form-group">
                <Btn block @clicked="validateForm">Create Account</Btn>
            </div>

            <div class="form-group form-group-footer">
                <p>Already have an account? <router-link to="/login">Login</router-link></p>
            </div>
        </div>
    </PageFrameInset>
</template>
<script>
    import firebase from 'firebase/app';
    import 'firebase/auth';


    import PageFrameInset from '@/components/PageFrameInset.vue'
    import Btn from '@/components/Btn.vue'
    import OSJInput from '@/components/OSJInput.vue'
    import OSJLabel from '@/components/OSJLabel.vue'

    export default {
        name: "register",
        components : {
            PageFrameInset,
            OSJInput,
            OSJLabel,
            Btn
        },
        data: function(){
            return{
                email: "",
                password: "",
                // theme and style
                theme: 'dark',
                size: 'small'
            }
        },
        methods: {
            signUp () {
                firebase
                    .auth()
                    .createUserWithEmailAndPassword(this.email, this.password)
                    .then( () => this.verifyEmail())
            },
            verifyEmail () {
                firebase
                    .auth().currentUser.sendEmailVerification()
                    .then( () => this.$router.replace('dashboard'));
            },
            validateForm ({event}) {
                event.preventDefault()
                if ( (this.email !== "") && (this.password !== "") ) {
                    this.signUp()
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../scss/vars";
    @import "../scss/wrapper";
    @import "../scss/layout";
    @import "../scss/forms";
     
    .site-top-padding{
        margin-top: 8rem;
    }
    .row {
        display: flex;
        flex-direction: column;
        margin: 1rem 0;
    }
    .form-group{
        margin-bottom: 2rem;

        &-header{
            border-bottom: 1px solid #ddd;
        }

        &-footer{
            border-top: 1px solid #ddd;
            padding-top: 2rem;
            text-align: center;

            a{
                display: inline-block;
                padding: 0.5rem;
                
                &:first-child{
                    margin-right: 0.5rem;
                }
            }
        }
    }
</style>